import { render, staticRenderFns } from "./varieties.vue?vue&type=template&id=f04da440"
import script from "./varieties.vue?vue&type=script&lang=js"
export * from "./varieties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports